import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';

function Input({
    options,
    onChange,
    onKeyPress,
    value,
    onBlur,
    onclickbackbutton,
    disableCopy,
    disablePaste,
}) {
    const [errorMessage, seterrorMessage] = useState(false);
    const [typeInput, setTypeInput] = useState(options.type);
    const [backIconType, setBackIconType] = useState(
        options.backButton ? options.backButton.type : ''
    );

    const onChangeInput = inputValue => {
        const value = options.event
            ? inputValue.currentTarget.value
            : inputValue;
        if (typeInput === 'email') {
            if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(value)) {
                seterrorMessage(false);
            } else {
                seterrorMessage(true);
            }
            // } else if (typeInput === 'dni') {
            //     if (/^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i.test(value)) {
            //         seterrorMessage(false);
            //     } else {
            //         seterrorMessage(true);
            //     }
        }
        onChange(inputValue);
    };

    const showErrorMessage = (optionerrorMessage, id) => {
        if (errorMessage) {
            return (
                <p className="c-error-message" id={'error-' + id}>
                    {optionerrorMessage}
                </p>
            );
        }
    };

    const hasLink = (link, id) => {
        if (link !== undefined) {
            return (
                <a
                    id={id + '-side-link'}
                    href={link.href}
                    className="c-form-field__side-link"
                    onClick={link.onClick}
                >
                    {link.textLink}
                </a>
            );
        }
    };

    const isError = () => {
        if (errorMessage) {
            return 'is-error';
        }
        return '';
    };

    const isRequired = isRequired => {
        if (isRequired) {
            return <span className="c-form-field__notion">*</span>;
        }
    };

    const classType = type => {
        switch (type) {
            case 'text':
            case 'hidden':
            case 'email':
            case 'password':
            case 'tel':
            case 'dni':
                return 'c-input__input  ';
            case 'number':
                return 'c-input__input  u-pr-none  ';
            case 'checkbox':
                return 'c-checkbox__input  ';
            default:
                break;
        }
    };

    const showLabelCheckbox = label => {
        if (label !== undefined) {
            return (
                <div className={'c-form-field__label ' + options.className}>
                    {label}
                </div>
            );
        }
    };

    const label = options.label ? (
        <label
            htmlFor={options.id}
            className={'c-form-field__label ' + options.className}
        >
            {options.label}
            {isRequired(options.isRequired)}
        </label>
    ) : null;

    const backLabel = options.backLabel ? (
        <label className="c-input__addon">{options.backLabel}</label>
    ) : null;

    const renderAttributes = values => {
        if (values === undefined) return '';
        let keys = Object.keys(values);
        let attr = [];

        keys.forEach(index => {
            attr['data-' + index] = values[index];
        });
        return attr;
    };

    const printBackButton = () => {
        if (options.backButton) {
            return (
                <button
                    type="button"
                    className="c-input__addon c-input__addon--no-background"
                    onClick={
                        options.backButton.type === 'control-eye-crossed' ||
                        options.backButton.type === 'control-eye'
                            ? showHidePassword
                            : onclickbackbutton
                    }
                    tabIndex="-1"
                >
                    <i
                        className={
                            'c-icon ' +
                            (backIconType
                                ? 'c-icon--[' + backIconType + ']'
                                : '')
                        }
                        aria-hidden="true"
                    ></i>
                </button>
            );
        } else {
            return null;
        }
    };

    const showHidePassword = () => {
        if (typeInput === 'password') {
            setTypeInput('text');
            setBackIconType('control-eye-crossed');
        } else {
            setTypeInput('password');
            setBackIconType('control-eye');
        }
    };

    const printComponent = () => {
        switch (typeInput) {
            case 'checkbox':
                return (
                    <div className="c-form-field  ">
                        {showLabelCheckbox(options.label)}
                        {isRequired(options.isRequired)}
                        <div
                            className={
                                'c-form-field__box u-pt-xsmall  ' +
                                options.className
                            }
                        >
                            <label className="c-checkbox">
                                <input
                                    checked={value}
                                    type="checkbox"
                                    onChange={e => {
                                        onChangeInput(
                                            options.event ? e : e.target.checked
                                        );
                                    }}
                                    id={options.id}
                                    disabled={options.disabled}
                                    name={options.name}
                                    className={`${classType(typeInput)} ${
                                        options.className
                                            ? options.className
                                            : ''
                                    }`}
                                    {...renderAttributes(
                                        options.customAttributes
                                    )}
                                ></input>
                                <span
                                    className={
                                        'c-checkbox__label ' +
                                        options.text.className
                                    }
                                >
                                    {' '}
                                    {options.text.text}{' '}
                                </span>
                            </label>
                        </div>
                    </div>
                );
            case 'file':
                return (
                    <label className="c-upload  " htmlFor="iae">
                        <input
                            className="c-upload__input"
                            type="file"
                            id={options.id}
                            name={options.id}
                            onChange={e =>
                                onChangeInput(
                                    options.event ? e : e.target.files
                                )
                            }
                        />

                        <span className="c-upload__description">
                            <i
                                className="c-upload__icon"
                                aria-hidden="true"
                            ></i>
                            {!value?.name && (
                                <span className="c-upload__description-text">
                                    {options.file.title}
                                </span>
                            )}
                            <span className="c-upload__description-supplementary-text">
                                {value?.name || options.file.description}
                            </span>
                        </span>

                        <span className="c-upload__actions">
                            <span className="c-upload__button  c-btn">
                                <span>{options.file.buttonText}</span>
                            </span>
                        </span>
                    </label>
                );
            default:
                return (
                    <div
                        className={`c-form-field u-1/1 ${
                            options?.container?.className || ''
                        }`}
                    >
                        {hasLink(options.link, options.id)}
                        {label}
                        <div className="c-form-field__box">
                            <div className={'c-input '}>
                                <input
                                    onChange={e =>
                                        onChangeInput(
                                            options.event ? e : e.target.value
                                        )
                                    }
                                    id={options.id}
                                    disabled={options.disabled}
                                    onBlur={onBlur}
                                    onPaste={e =>
                                        disablePaste ? e.preventDefault() : null
                                    }
                                    onCopy={e =>
                                        disableCopy ? e.preventDefault() : null
                                    }
                                    name={options.name}
                                    className={[
                                        classType(typeInput),
                                        isError(),
                                        options.className !== undefined
                                            ? options.className
                                            : '',
                                    ].join(' ')}
                                    value={value}
                                    type={typeInput}
                                    placeholder={options.placeHolder}
                                    autoComplete={options.autoComplete}
                                    {...renderAttributes(
                                        options.customAttributes
                                    )}
                                    onKeyPress={onKeyPress ? onKeyPress : null}
                                    maxLength={
                                        options.maxlength
                                            ? options.maxlength
                                            : ''
                                    }
                                    readOnly={options?.readOnly}
                                    pattern={options?.pattern}
                                />
                                {backLabel}
                                {printBackButton()}
                            </div>
                            {showErrorMessage(options.errorMessage, options.id)}
                        </div>
                    </div>
                );
        }
    };

    return <React.Fragment>{printComponent()}</React.Fragment>;
}

Input.propTypes = {
    options: PropTypes.shape({
        label: PropTypes.string,
        backLabel: PropTypes.string,
        text: PropTypes.shape({
            text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
            className: PropTypes.string,
        }),
        file: PropTypes.shape({
            text: PropTypes.string,
            description: PropTypes.string,
            buttonText: PropTypes.string,
        }),
        placeHolder: PropTypes.string,
        type: PropTypes.string.isRequired,
        name: PropTypes.string,
        isRequired: PropTypes.bool,
        id: PropTypes.string,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        link: PropTypes.shape({
            href: PropTypes.string,
            textLink: PropTypes.string,
        }),
        customAttributes: PropTypes.shape({
            data: PropTypes.string,
            value: PropTypes.string,
        }),
        backButton: PropTypes.shape({
            type: PropTypes.string,
            onclick: PropTypes.string,
        }),
        pattern: PropTypes.string,
    }).isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
    ]),
    onChange: PropTypes.func.isRequired,
};
export default memo(Input);
